export default "__VITE_ASSET__BVE$$rNg__"